import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import ContactStateLegislators from "../components/contact-state-legislators"

export default function MoreInfo() {
  const links = [
    {
      url: "https://wakeca.org/",
      text: "Wake Up California",
    },
    {
      url: "https://www.livablecalifornia.org/",
      text: "Livable California (Open to anyone interested)",
    },
    {
      text: `CALE - California Alliance of Local Electeds (Primarily intended for
        Elected Officials)`,
      url: "https://www.caleelecteds.org/",
    },
    {
      text: "United Neighbors",
      url: "/documents/united-neighbors.pdf",
    },
    {
      text: "Our Neighborhood Voices",
      url: "https://ourneighborhoodvoices.com/",
    },
  ]
  return (
    <Layout>
      <SEO title="More Info" />
      <h1 className="text-center">More Info</h1>
      <p>
        For those wanting more information on various bills and to participate
        in regular discussion on these important issues, please considering
        signing up with any of the following groups which are doing great work
        to help protect Cities from overreach by the State:
      </p>
      <ul className="ml-5 list-disc list-outside">
        {links.map(({ text, url }) => {
          return (
            <li key={url}>
              <a href={url} target="_blank" rel="noreferrer">
                {text}
              </a>
            </li>
          )
        })}
      </ul>
      <p>The more you get involved, the better we hope the results will be!</p>
      <ContactStateLegislators />

      <blockquote className="px-5">
        <h2>Important News</h2>
        <p>
          Sacramento Legislators continue their attack on Cities ability to
          manage their own land-use and zoning. And CCLC is continuing our
          efforts to bring attention to the bills that impact cities in this
          way, and to lobby legislators to stop the passage of these types of
          bills, and instead support bills that encourage desired behaviors,
          while respecting the individuality of Cities.
        </p>

        <a
          href="https://ourneighborhoodvoices.com/"
          target="_blank"
          rel="noreferrer"
        >
          <img
            src="/images/our-neighborhood-voices.png"
            alt="Our Neighborhood Voices"
            width="300"
            className="float-left mr-5"
          />
        </a>

        <p>
          While SB9 and SB10 did pass in the the 2021 legislative session, CCLC
          still supports efforts to minimize or even stop the impacts of these
          bills. One way is the continued support of the ballot initiative by
          ‘Our Neighborhood Voices’, which is now being setup to try to get on
          the November 2026 ballot. And another way we are helping to fight back
          is via legal efforts, of which several options are in progress.
        </p>

        <p>
          CCLC will continue to highlight good and bad bills impacting local
          land-use and zoning, as well as keep everyone up to date on the
          efforts to get a ballot initiative on the ballots to allow the voters
          a say. And lastly, we will share ways Cities can get involved in the
          legal battles, which stand the best chances of success with the
          support of many Cities. We hope you will continue to support our
          efforts!
        </p>
        <p className="mb-0">
          Join in our efforts now! Together, we can stop Sacramento from
          "unplanning" our communities.
        </p>
      </blockquote>
    </Layout>
  )
}
